import { post, serialize } from '../httpClient';

// Core application APIs that don't fit into specific domains
export const coreAPI = {
  transactionLineItems: body => post('/api/transaction-line-items', body),
  initiatePrivileged: body => post('/api/initiate-privileged', serialize(body)),
  transitionPrivileged: body => post('/api/transition-privileged', serialize(body)),
};